import { Theme } from '@mui/material/styles';
import { openSansBold, openSansRegular } from 'common-tridium/fonts/fonts.tss';
import { lexusFontsFaces } from 'common-tridium/fonts/lexus.fonts.jss';
import { toyotaFontsFaces } from 'common-tridium/fonts/toyota.fonts.jss';

export const getStyles = (
  appSelector: string,
  theme: Theme
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Record<string, any> => {
  return {
    [appSelector]: {
      margin: '0 auto',
      WebkitFontSmoothing: 'antialiased', // Antialiasing.
      MozOsxFontSmoothing: 'grayscale', // Antialiasing.
      boxSizing: 'border-box',
      color: 'theme.palette.text.primary',
      backgroundColor: theme.palette.background.paper,
      minHeight: '350px',
      position: 'relative',
      display: 'block',
      WebkitTextSizeAdjust: '100%',
      '& @media print': {
        backgroundColor: theme.palette.common.white,
      },
      '&::backdrop': {
        backgroundColor: theme.palette.background.default,
      },
      '& *::before, & *::after': {
        boxSizing: 'border-box',
      },
      '& strong, & b': {
        fontWeight: 'bolder',
      },
      '& p': {
        textIndent: '0',
      },
    },
    '.tis-element-container': {
      position: 'relative',
      minHeight: '350px',
      '&.insurance-container-width': {
        maxWidth: '100%',
        width: '1440px',
        lineHeight: 'normal',
      },
      '&.insurance-container-in-body': {
        position: 'relative',
        padding: '0 0 10px 0',
        maxWidth: '100%',
        width: '100%',
      },
      '&.insurance-container-speedboat': {
        minHeight: '320px',
      },
    },
    '.mlb-tim-r5jkvq-40': {
      padding: 0,
    },
    '.MuiBox-root': {
      padding: 0,
    },
    '.MuiContainer-root': {
      padding: 0 + '!important',
    },
  };
};

export const loadBrandFonts = (brand: string | undefined): void => {
  const style = document.createElement('style');
  document.head.append(style);
  const fontsFaces = brand === 'lexus' ? lexusFontsFaces : toyotaFontsFaces;
  const fonts = [...fontsFaces, openSansRegular, openSansBold];

  const styleContent = fonts
    .map(
      (font) => `
      @font-face {
        font-family: ${font.fontFamily};
        src: ${font.src};
        font-weight: ${font.fontWeight};
        font-style: ${font.fontStyle};
      }`
    )
    .join('');
  style.innerHTML = styleContent;
};
